import { render, staticRenderFns } from "./ImportPageFromProject.vue?vue&type=template&id=11786a1b"
import script from "./ImportPageFromProject.vue?vue&type=script&lang=js"
export * from "./ImportPageFromProject.vue?vue&type=script&lang=js"
import style0 from "./ImportPageFromProject.vue?vue&type=style&index=0&id=11786a1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports